import { Component } from 'opus-angular-seed-core';
import { trashIcon } from '../fileIcon';
@Component({
    bindings: {
        files: '=',
        entityType: '<',
        entityId: '<',
        onFileDetached: '&'
    },
    template: `
        <table class="data01 mt2em file-list__table" ng-if="vm.files.length">
            <colgroup>
                <col width="35%"/>
                <col width="25%"/>
                <col width="20%"/>
                <col width="20%"/>
            </colgroup>
            <thead>
            <tr>
                <th>{{ 'file.Name' | translate }}</th>
                <th>{{ 'file.Uploaded by' | translate }}</th>
                <th>{{ 'file.Upload date' | translate }}</th>
                <th>{{ 'file.Actions' | translate }}</th>
            </tr>
            </thead>
            <tbody>
            <tr ng-repeat="item in vm.files">
                <td style="vertical-align: middle">
                    <div class="file-list__name">
                        <file-file-icon filename="item.filename"></file-file-icon>
                        <strong class="file-list__name-text">
                            <a ng-click="vm.downloadFile(item.fileHash)" title="{{ item.filename }}">{{ item.filename }}</a>
                        </strong>
                    </div>
                </td>
                <td style="vertical-align: middle">{{ item.uploadedByName }}</td>
                <td style="vertical-align: middle">{{ vm.formatDate(item.uploadedAt) }}</td>
                <td class="actions" style="vertical-align: middle">
                    <a class="btn" ng-click="vm.removeFile(item)"><span class="file-icon file-icon--sm" ng-bind-html="vm.trashIconHtml"></span> {{ 'file.Remove' | translate }}</a>
                </td>
            </tr>
            </tbody>
        </table>
        <style>
            .file-list__table {
                table-layout: fixed;
            }
            .file-list__table th {
                white-space: normal;
                word-break: break-word;
                overflow-wrap: break-word;
            }
            .file-list__name {
                display: flex;
                align-items: center;
                min-width: 0;
            }
            .file-list__name-text {
                min-width: 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .file-list__name-text a {
                display: block;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                word-break: break-all;
            }
        </style>
    `
})
export default class {
    constructor (FileService, AuthResource, MomentService, $window, toastr, $translate, $sce) {
        this.FileService = FileService;
        this.trashIconHtml = $sce.trustAsHtml(trashIcon);
        this.AuthResource = AuthResource;
        this.MomentService = MomentService;
        this.$window = $window;
        this.toastr = toastr;
        this.$translate = $translate;
    }
    formatDate (datetime) {
        return this.MomentService.format(datetime, 'DD.MM.YYYY');
    }
    downloadFile (fileHash) {
        this.AuthResource
            .requestTacToken().$promise
            .then((response) => {
                const url = `${this.FileService.getDownloadUrl(fileHash)}?tacToken=${response.token}`;
                this.$window.open(url);
            });
    }
    removeFile (item) {
        this.FileService.detach(item.fileHash, this.entityType, this.entityId).then(() => {
            const index = this.files.indexOf(item);
            if (index > -1) {
                this.files.splice(index, 1);
            }
            this.toastr.success(this.$translate.instant('file.File removed successfully'));
            if (this.onFileDetached) {
                this.onFileDetached();
            }
        }).catch(() => {
            this.toastr.error(this.$translate.instant('file.Failed to remove file'));
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/file/fileList/index.js